import { render, staticRenderFns } from "./BillForm.vue?vue&type=template&id=020756a2&scoped=true"
import script from "./BillForm.vue?vue&type=script&lang=js"
export * from "./BillForm.vue?vue&type=script&lang=js"
import style0 from "./BillForm.vue?vue&type=style&index=0&id=020756a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020756a2",
  null
  
)

export default component.exports